import styled from 'styled-components';
import { media } from 'lib';

export const LoginArea = styled.div`
  float: right;
  display: flex;
  align-items: center;
  height: 60px;

  .icon-login {
    width: 24px;
    height: 24px;
    margin-right: 20px;
  }

  .btn-first-charge {
    background: url(${require('./images/btn-first-charge.png')}) no-repeat
      center;
    width: 80px;
    height: 32px;
    box-sizing: border-box;
  }

  .btn + .btn {
    margin-left: 10px;
  }

  .icon-header-coin {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 0 4px;
    background: url(${require('./images/icon-coin.png')}) no-repeat center;
  }

  .user-coin {
    margin-right: 14px;
    font-size: 12px;
    color: #fff;
    max-width: 80px;
  }

  .avatar {
    position: relative;
    margin: 0 10px;
    padding: 6px 0;
    > img {
      display: inline-block;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      cursor: pointer;
      vertical-align: top;
    }
  }
  .start-live {
    margin-right: 10px;
    font-size: 14px;
    height: 60px;
    position: relative;
    .text-second {
      line-height: 60px;
    }
    .menu {
      display: none;
      .item {
        width: 120px;
        display: inline-block;
      }
    }
    &:hover .menu {
      display: block;
    }
  }
`;

const Header = styled.div`
  height: 60px;
  background: #2d2d2d;
  //margin-right: -70px;
  //padding-right: 70px;
  position: relative;
  &:hover {
    z-index: 90000;
  }

  .page-live & {
    padding-left: 30px;
    padding-right: 70px;
  }

  //.page-live &{
  //  .container{
  //    width: auto;
  //    max-width:1570px;
  //  }
  //}

  /*.container{
    margin:0 auto;
    width:${media.width.sm}px;
    ${media.mediaMd}{
      width:${media.width.md}px;
    }
    ${media.mediaLg}{
      width:${media.width.lg}px;
    }
  }*/

  .icon-header {
    display: inline-block;
    background: url(${require('./images/header-icons.png')}) 0 0 no-repeat;
  }

  .icon-header-qrcode {
    width: 132px;
    height: 132px;
    background: url(${require('./images/download-qr.png')}) 0 0 no-repeat;
    background-size: 132px 132px;
  }

  .icon-header-mobile-download {
    width: 10px;
    height: 19px;
    background-position: -284px -66px;
  }

  .icon-header-login-weibo {
    width: 24px;
    height: 24px;
    background-position: -212px -66px;
  }

  .icon-header-login-wechat {
    width: 24px;
    height: 24px;
    background-position: -236px -66px;
  }

  .icon-header-login-qq {
    width: 24px;
    height: 24px;
    background-position: -260px -66px;
  }

  .icon-header-coin {
    width: 12px;
    height: 12px;
    background-position: -294px -66px;
  }

  .container {
    height: 100%;
    margin-top: 0;

    .header-left,
    .header-login-area {
      float: left;
      height: 100%;

      > * {
        float: left;
      }
    }

    .header-login-area {
      float: right;
    }
  }

  .link-home {
    width: 121px;
    height: 33px;
    margin: 13.5px 0 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .btn-mobile-download {
    position: relative;
    margin: 13.5px 0 0 10px;

    > i {
      float: left;
      width: 10px;
      height: 19px;
      margin: 0 6px 0 0;
    }

    span {
      float: left;
      line-height: 19px;
    }

    &:hover .header-qrcode {
      display: block;
    }

    .header-qrcode {
      display: none;
      position: absolute;
      left: 50%;
      top: 45px;
      padding: 4px 4px 10px;
      margin: 0 0 0 -70px;
      background-color: ${(props) => props.theme.color.white};
      border-radius: 6px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
      z-index: 100;

      &::after {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        content: ' ';
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid ${(props) => props.theme.color.white};
      }

      .icon-header-qrcode {
        display: block;
      }

      div {
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #333;
      }
    }
  }

  .header-navs {
    margin: 0 0 0 30px;

    .nav {
      float: left;
      position: relative;
      padding: 20px 10px;
      margin: 0 15px 0 0;
      font-size: 14px;
      color: #fff;
      line-height: 20px;
      background: none;
      border: none;
      cursor: pointer;
      outline: none;

      &.active,
      &:hover {
        color: ${(props) => props.theme.color.second};

        .nav-bottom-line {
          display: block;
        }
      }

      .nav-bottom-line {
        display: none;
        position: absolute;
        left: 50%;
        bottom: 5px;
        transform: translateX(-50%);
        width: 28px;
        height: 3px;
        border-radius: 2px;
        background: ${(props) => props.theme.color.second};
      }
    }
  }

  // 用户登录状态
  .user-login-area {
    > .btn {
      margin: 14px 24px 0 0;
      width: 80px;
      height: 32px;
      line-height: 32px;
      padding: 0;
      border: none;
    }

    .user-top-center {
      position: relative;
      height: 48px;
      margin: 6px 0 0;

      .header-user-avatar {
      }
    }

    .user-top-live {
      height: 60px;
      line-height: 60px;
      padding-left: 10px;
      white-space: nowrap;
      position: relative;
      > a {
        font-size: 14px;
        line-height: 1;
        color: ${(props) => props.theme.color.second};
        text-decoration: underline;
      }
      &-menu {
        display: none;
        position: absolute;
        right: 0;
        top: 100%;
        width: 150px;
        padding: 5px 0;
        border-radius: 4px;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
        overflow: hidden;
        z-index: 100;
        line-height: 30px;
        background: #fff;
        font-size: 14px;
        &-title {
          font-weight: bold;
          padding: 0 10px;
        }
        li {
          a {
            padding: 0 10px 0 20px;
            color: $gray;
            display: block;

            &:hover {
              color: #fff;
              background-color: ${(props) => props.theme.color.second};
            }
          }
        }
      }
      &:hover {
        .user-top-live-menu {
          display: block;
        }
      }
    }
  }
`;

export default Header;
